import { MAX_OPTION } from 'sdk';
import { client, formatQueryParams } from 'util/sdk';

export default () =>
  client.admin.actions.query(
    formatQueryParams({ orderByName: 'asc', ...MAX_OPTION })
  );
